Vue.component('state-register', {
    data: function() {
        let name = '';
        if (window.localStorage) {
            name = window.localStorage.getItem('name');
        }
        return {
            loading: false,
            profileName: name,
            email: '',
            password: '',
            passwordRetype: ''
        };
    },
    methods: {
        submit: function(e) {
            e.preventDefault();
            //game.playSound('button_click');
            if (!game.verifyName(this.profileName)) {
                return;
            }
            if (this.password.trim() !== this.passwordRetype.trim()) {
                game.showGrowl('Passwords do not match.', {type: 'danger'});
                return;
            }

            this.loading = true;
            axios.post(API_URL + '/register', {
                profileName: this.profileName,
                email: this.email,
                password: this.password
            }).then((res) => {
                this.loading = false;
                if (res.data.success) {
                    game.services.user.login('bsg', {
                        email: this.email,
                        password: this.password
                    }, this).then(() => {
                        //this.loading = false;
                    }, () => {
                        this.loading = false;
                    });
                } else {
                    game.showGrowl('Error: ' + res.data.message, {type: 'danger'});
                }
            }, () => {
                this.loading = false;
                game.showGrowl('Error: Failed to register.', {type: 'danger'});
            });
        },
        bmc: function() {
            //game.playSound('button_click');
        },
        bme: function() {
            //game.playSound('button_hover');
        }
    },
    template: `
    <div class="vertical-center">
        <div v-if="loading">
            <h1><i class="fa fa-refresh fa-spin fa-2x"></i></h1>
        </div>
        <div v-if="!loading">
            <div class="app-card text-center">
                <form @submit="submit">
                    <h1><i class="fa fa-user"></i> Register</h1>
                    <label class="text-left">
                        Name
                        <input v-model="profileName" required="required" type="text" class="app-input" placeholder="Name">
                    </label>
                    <br>
                    <label class="text-left">
                        Email
                        <input v-model="email" required="required" type="email" class="app-input" placeholder="Email">
                    </label>
                    <br>
                    <label class="text-left">
                        Password
                        <input v-model="password" minlength="6" required="required" type="password" class="app-input" placeholder="Password">
                    </label>
                    <label class="text-left">
                        Retype Password
                        <input v-model="passwordRetype" required="required" type="password" class="app-input" placeholder="Retype Password">
                    </label>
                    <br><br>
                    <button type="submit" class="app-btn app-btn-secondary btn-sm" @mouseenter="bme">
                        <i class="fa fa-sign-in"></i> Submit
                    </button>
                </form>
            </div>
        </div>
    </div>
    `
})